module.exports = __webpack_public_path__ + "static/app-store-badge-d0558d91063038236b60e3ef71fdc1fd.svg";